import { useEffect, useState, useMemo } from "react";
import { Group, FormControl, Grid, Layout, Button, Icon, TGridRenderSchema } from "@/comn/components";
import { useForm, useGrid, TGridSchema, TFormSchema, usePopup, useModal, useResource, useFetch } from "@/comn/hooks";
import { api } from "@/comn";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Sample } from "@/comn/components/_";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Process, TProcessItem } from "@/comn/components/Process";

const FORM_SCHEMA: TFormSchema = {
    id: "form",
    schema: {
        daterange: {
            type: "daterange",
            label: "Date Range",
            start: { name: "startDate", required: true },
            end: {
                name: "endDAte",
                required: true,
                // value : 종료일자의 값 , formValues : 폼의 값들
                validate: (value: any, formValues: any) => {
                    // 종료일자와 시작일자를 비교하여 오류검증 실행
                    // formValues.startDate 처럼 시작일자(startDate) 필드를 지정해서 비교
                    return comnUtils.dateDiff(value, formValues.startDate) < 0 ? "msg.osc.00049" : true;
                },
            },
            required: true,
        },
        timerange: {
            type: "timerange",
            label: "Time Range",
            start: { name: "startTime", required: true },
            end: {
                name: "endTime",
                required: true,
                // value : 종료일자의 값 , formValues : 폼의 값들
                validate: (value: any, formValues: any) => {
                    // 종료시간과 시작시간을 비교하여 오류검증 실행
                    // formValues.startTime 처럼 시작시간(startTime) 필드를 지정해서 비교
                    // m : 분단위 비교 파라메터
                    return comnUtils.dateDiff(value, formValues.startTime, "m") < 0 ? "msg.osc.00115" : true;
                },
            },
            required: true,
        },
    },
};

const mock = ({ totalElements = 99 }) => {
    return {
        page: { totalElements, page: 0, size: 100 },
        content: Array(totalElements)
            .fill(null)
            .map((_) => ({
                dept: ["Dept 1", "Dept 2", "Dept 3", "Dept 4"][Math.floor(Math.random() * 4)],
                name: ["Maru", "Sam", "Tom", "Ken"][Math.floor(Math.random() * 4)],
                field: Math.ceil(Math.random() * 1000),
            })),
    };
};

export const SG_GRID: TGridSchema = {
    id: "grid",
    options: { pagination: "in", height: 300, group: ["dept", "name"], checkbox: true },
    head: [
        { cells: [{ header: "Dept", binding: "dept", width: 150 }] },
        { cells: [{ header: "Name", binding: "name", width: 150 }] },
        { cells: [{ header: "Field", binding: "field", width: "*" }] },
    ],
    body: [{ cells: [{ binding: "dept" }] }, { cells: [{ binding: "name" }] }, { cells: [{ binding: "field" }] }],
    groupFoot: [
        {
            cells: [
                {
                    colspan: 1,
                },
            ],
        },
        {
            cells: [
                {
                    colspan: 2,
                    binding: "field",
                    aggregate: "MAX",
                    align: "center",
                    render: (props: any) => {
                        const { depth, seq, group, sum, average, min, max, count } = props;
                        if (depth == 0) {
                            return `Dept ${seq[0] + 1} 번째 ${
                                group[0]
                            }의 합은 ${sum}, 평균은 ${comnUtils.getFormattedNumber(
                                average,
                                1,
                            )}, 최소값은 ${min}, 최대값은 ${max}, 최소값은 ${min}, 갯수는 ${count} 입니다`;
                        } else {
                            return `Dept ${seq[0] + 1} 번째 ${group[0]}, Name ${seq[1] + 1} 번째 ${
                                group[1]
                            } 의 합은 ${sum}, 평균은 ${comnUtils.getFormattedNumber(
                                average,
                                1,
                            )}, 최소값은 ${min}, 최대값은 ${max}, 최소값은 ${min}, 갯수는 ${count} 입니다`;
                        }
                    },
                },
            ],
        },
    ],
};
export const SG_TCLSF_AR_VRFN_LIST: TGridSchema = {
    id: "grid_ClriTclsfArVrfnList",
    options: {
        radio: false,
        checkbox: false,
        pagination: "in",
        index: true,
        edit: false,
        add: true,
        // height: 200,
    },
    head: [
        { cells: [{ header: "L_RGSR_NO", binding: "", width: "15%" }], id: "rgsrNo" },
        { cells: [{ header: "L_RGSR_DT", binding: "tclsfArRgsrDt", width: "10%" }] },
        { cells: [{ header: "L_CSCL_XPTD_CSTM", binding: "csclXptdCstmOfceCd", width: "10%" }] },
        { cells: [{ header: "L_APLC_TIN", binding: "tclsfArAplcTin", width: "10%" }] },
        { cells: [{ header: "L_VRFN_OFCR", binding: "vrfnOfcrNm", width: "17%" }] },
        { cells: [{ header: "L_GODS_NM", binding: "aplyGodsNm", width: "18%" }] },
        { cells: [{ header: "L_SMPL_SBMT_YN", binding: "smplSbmtYn", width: "10%" }] },
        { cells: [{ header: "L_STTS", binding: "tclsfArPrcssSttsCd", width: "*" }] },
    ],
    body: [
        {
            cells: [
                { binding: "rgsrNo" },
                { binding: "rgsrNo" },
                { binding: "rgsrNo" },
                { binding: "rgsrNo" },
                { binding: "rgsrNo" },
                { binding: "rgsrNo" },
            ],
        },
        //{ cells: [{ binding: "tclsfArAplySrno"                                                     }] },
        {
            cells: [
                { binding: "tclsfArRgsrDt", type: "date" },
                { binding: "tclsfArRgsrDt", type: "date" },
                { binding: "tclsfArRgsrDt", type: "date" },
                { binding: "tclsfArRgsrDt", type: "date" },
                { binding: "tclsfArRgsrDt", type: "date" },
                { binding: "tclsfArRgsrDt", type: "date" },
            ],
        },
        {
            cells: [
                { binding: "csclXptdCstmOfceCd" },
                { binding: "csclXptdCstmOfceCd" },
                { binding: "csclXptdCstmOfceCd" },
                { binding: "csclXptdCstmOfceCd" },
                { binding: "csclXptdCstmOfceCd" },
                { binding: "csclXptdCstmOfceCd" },
            ],
        },
        {
            cells: [
                { binding: "tclsfArAplcTin" },
                { binding: "tclsfArAplcTin" },
                { binding: "tclsfArAplcTin" },
                { binding: "tclsfArAplcTin" },
                { binding: "tclsfArAplcTin" },
                { binding: "tclsfArAplcTin" },
            ],
        },
        {
            cells: [
                { binding: "vrfnOfcrNm", align: "left" },
                { binding: "vrfnOfcrNm", align: "left" },
                { binding: "vrfnOfcrNm", align: "left" },
                { binding: "vrfnOfcrNm", align: "left" },
                { binding: "vrfnOfcrNm", align: "left" },
                { binding: "vrfnOfcrNm", align: "left" },
            ],
        },
        {
            cells: [
                { binding: "aplyGodsNm", align: "left" },
                { binding: "aplyGodsNm", align: "left" },
                { binding: "aplyGodsNm", align: "left" },
                { binding: "aplyGodsNm", align: "left" },
                { binding: "aplyGodsNm", align: "left" },
                { binding: "aplyGodsNm", align: "left" },
            ],
        },
        {
            cells: [
                { binding: "smplSbmtYn" },
                { binding: "smplSbmtYn" },
                { binding: "smplSbmtYn" },
                { binding: "smplSbmtYn" },
                { binding: "smplSbmtYn" },
                { binding: "smplSbmtYn" },
            ],
        },
        {
            cells: [
                { rowspan: 2, binding: "tclsfArPrcssSttsCd1", type: "code", area: "comnCd", comnCd: "OSC0045" },
                { rowspan: 2, binding: "tclsfArPrcssSttsCd2", type: "code", area: "comnCd", comnCd: "OSC0045" },
                { rowspan: 2, binding: "tclsfArPrcssSttsCd3", type: "code", area: "comnCd", comnCd: "OSC0045" },
            ],
            colspan: 1,
        },
    ],
};

export const GuideTemp = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0008" },
            { area: "wrhsCd" },
            { area: "coDclaCd" },
            { area: "cityCd" },
        ],
    });

    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const form = useForm({ defaultSchema: FORM_SCHEMA });
    const grid3 = useGrid({ defaultSchema: SG_GRID, size: 100 });
    const grid2 = useGrid({ defaultSchema: SG_TCLSF_AR_VRFN_LIST, size: 100 });
    const data = useMemo(() => mock({ totalElements: 100 }), []);

    const prcsItm1: TProcessItem[] = [
        {
            icon: "start",
            title: "Start",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "inProgress",
            title: "Step 1",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "inProgress",
            title: "Step 2",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "inProgress",
            title: "Step 3",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "completed",
            title: "End",
            current: true,
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
    ];

    const prcsItm2: TProcessItem[] = [
        {
            icon: "start",
            title: "Start",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
            line: "dashed",
        },
        {
            icon: "inProgress",
            title: "Step 1",
            color: "yellow",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "inProgress",
            title: "Step 2",
            current: true,
            line: "dashed",
            lineColor: "yellow",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "error",
            title: "Step Error",
            color: "red",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
        {
            icon: "completed",
            title: "End",
            description: "단계에 해당하는 간단한 설명을 입력합니다",
        },
    ];

    const render: TGridRenderSchema = {
        grid_RpckItmAppList: {
            cell: {
                dclrNo: (props) => {
                    const { binding, rowValues, value } = props;

                    return (
                        <Link
                            to={`#!`}
                            onClick={() => {}}
                        >{`${rowValues.dcltTin}-${rowValues.dclrYy}-${rowValues.prcsTpCd}-${rowValues.dclrSrno}`}</Link>
                    );
                },
            },
        },
    };

    return (
        <Sample title="업데이트(2024.07.01~)" description="">
            <Sample.Section
                title="1. Daterange(Timerange) 기본 오류검증"
                description={
                    <>
                        - Schema의 validate 함수를 이용한 기본 오류검증
                        <br />
                        - comnUtils.dateDiff 함수를 이용하여 비교 <br />- 종료일자(시간)이 시작일자(시간보다) 작은 경우
                        메시지 ID 리턴
                        <br />- form 의 handleSubmit 을 실행하였을 경우 오류검증 실행
                    </>
                }
            >
                <Sample.Table
                    widths={["w-[15%]", "w-[30%]", "w-auto"]}
                    data={[
                        ["Method", "파라메터", "설명"],
                        [
                            "validate",
                            <>
                                value : 해당 필드의 값
                                <br />
                                formValues : 해당 Form의 값들
                            </>,
                            <>
                                - 리턴값에 따른 오류 검증 결과 표시
                                <br />
                                false: 오류 (기본요류메시지 출력)
                                <br />
                                string(메시지 ID): 오류 (해당 메시지 ID를 출력)
                                <br /> true: 오류없음
                                <br /> void : 오류없음
                            </>,
                        ],
                        [
                            "comnUtils.dateDiff( end , start , part )",
                            <>
                                start : 시작시간
                                <br />
                                end : 종료시간
                                <br />
                                part : 날짜 비교 단위(기본값 d)
                            </>,
                            <>
                                0 : 시작시간과 종료시간이 같음
                                <br />
                                음수(-) : 시작시간보가 종료시간이 작음
                                <br /> 양수(+) : 시작시간보다 종료시간이 큼
                            </>,
                        ],
                    ]}
                />
                <Sample.Code>
                    {`const FORM_SCHEMA: TFormSchema = {
    id: "form",
    schema: {
        daterange: {
            type: "daterange",
            label: "Date Range",
            start: { name: "startDate", required: true },
            end: {
                name: "endDAte",
                required: true,
                // value : 종료일자의 값 , formValues : 폼의 값들
                validate: (value: any, formValues: any) => {
                    // 종료일자와 시작일자를 비교하여 오류검증 실행
                    // formValues.startDate 처럼 시작일자(startDate) 필드를 지정해서 비교
                    return comnUtils.dateDiff(value, formValues.startDate) < 0 ? "msg.osc.00049" : true;
                },
            },
            required: true,
        },
        timerange: {
            type: "timerange",
            label: "Time Range",
            start: { name: "startTime", required: true },
            end: {
                name: "endTime",
                required: true,
                // value : 종료일자의 값 , formValues : 폼의 값들
                validate: (value: any, formValues: any) => {
                    // 종료시간과 시작시간을 비교하여 오류검증 실행
                    // formValues.startTime 처럼 시작시간(startTime) 필드를 지정해서 비교
                    // m : 분단위 비교 파라메터
                    return comnUtils.dateDiff(value, formValues.startTime, "m") < 0 ? "msg.osc.00115" : true;
                },
            },
            required: true,
        },
    },
};
....

 <Button
    role="save"
    onClick={() => {
        form.handleSubmit(
            (data) => {
                // save handle
            },
            (error) => {
                // error handle
            },
        )();
    }}
></Button>

`}
                </Sample.Code>
                <Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.schema.daterange} controlSize={10}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.schema.timerange} controlSize={10}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Layout>
                <Layout>
                    <Layout.Right>
                        <Button
                            role="save"
                            onClick={() => {
                                form.handleSubmit(
                                    (data) => {
                                        // save handle
                                    },
                                    (error) => {
                                        // error handle
                                    },
                                )();
                            }}
                        ></Button>
                    </Layout.Right>
                </Layout>
            </Sample.Section>

            <Sample.Section
                title="2. Grid Group Row 활용"
                description={
                    <>
                        - 그리드의 스키마 중 group, groupFoot 에서 그룹된 데이터의 수치값(평균, 최대, 최소, 합계,
                        갯수)들을 사용하기 쉽게 제공하는 기능 추가
                        <br />
                        - group, groupFoot 스키마에서 render 메소드를 사용하여 자유롭게 문자열을 조합
                        <br />- 그룹관련된 수치값, 그룹 정보를 props로 제공
                    </>
                }
            >
                <Sample.Table
                    widths={["w-[20%]", "w-auto"]}
                    data={[
                        ["제공값", "타입", "설명"],
                        [
                            "depth",
                            "number",
                            <>
                                그룹을 만드는 순서 인덱스
                                <br />
                                option 스키마에 group : [ "필드1" , "필드2" ] 값의 index
                                <br />
                                필드1 : 0, 필드2 : 1
                            </>,
                        ],
                        [
                            "seq",
                            "Array<number>",
                            <>
                                depth 그룹별로 현재 그룹의 인덱스 배열
                                <br />
                                [ 필드1 그룹에서의 인덱스 , 필드2 그룹에서의 인덱스 ]
                                <br />
                            </>,
                        ],
                        [
                            "group",
                            "Array<any>",
                            <>
                                depth 그룹별 현재 값
                                <br />
                                [ 1 depth 그룹의 현재 값 , 2 depth 그룹의 현재 값 ]
                                <br />
                            </>,
                        ],
                        ["sum", "number", <>현재 그룹의 집계 값(합)</>],
                        ["average", "number", <>현재 그룹의 집계 값(평균)</>],
                        ["min", "number", <>현재 그룹의 집계 값(최소값)</>],
                        ["max", "number", <>현재 그룹의 집계 값(최대값)</>],
                        ["count", "number", <>현재 그룹의 집계 값(갯수)</>],
                    ]}
                />
                <Sample.Code>{`export const SG_GRID: TGridSchema = {
    id: "grid",
    options: { pagination: "in", height: 300, group: ["dept", "name"] },
    head: [ ... ],
    body: [ ... ],
    groupFoot: [
        {
            cells: [
                {
                    colspan: 1,
                },
            ],
        },
        {
            cells: [
                {
                    colspan: 2,
                    binding: "field",
                    aggregate: "MAX",
                    align: "center",
                    render: (props: any) => {
                        const { depth, seq, group, sum, average, min, max, count } = props;
                        if (depth == 0) {
                            return \`Dept \${seq[0] + 1} 번째 \${
                                group[0]
                            }의 합은 \${sum}, 평균은 \${average}, 최소값은 \${min}, 최대값은 \${max}, 최소값은 \${min}, 갯수는 \${count} 입니다\`;
                        } else {
                            return \`Dept \${seq[0] + 1} 번째 \${group[0]}, Name \${seq[1] + 1} 번째 \${
                                group[1]
                            } 의 합은 \${sum}, 평균은 \${average}, 최소값은 \${min}, 최대값은 \${max}, 최소값은 \${min}, 갯수는 \${count} 입니다\`;
                        }
                    },
                },
            ],
        },
    ],
};`}</Sample.Code>
                <Layout>
                    <Layout.Right>
                        <Button
                            onClick={() => {
                                grid3.deleteRow(grid3.getData());
                            }}
                        >
                            삭제
                        </Button>
                    </Layout.Right>
                </Layout>
                <Layout>
                    <Grid {...grid3.grid} data={data} />
                </Layout>
            </Sample.Section>
            <Sample.Section
                title="3.다중 Grid 데이터 엑셀다운로드(다중 Sheet)"
                description={`한개 이상의 그리드의 데이터를 엑셀에 시트로 구분하여 하나의 엑셀로 다운로드 하는 기능 추가`}
            >
                <Sample.Code>{`<Button
    role="excelDown"
    onClick={async () => {
        // onClick 이벤트는 async로 비동기 선언
        // Grid의 exportSheet 메소드로 Sheet 데이터 생성
		// await 로 비동기 처리
        const ws1 = await grid.rpckItmAppList.exportSheet();
        const ws2 = await grid.rpckItmAppList.exportSheet();

        // comnUtils.exportExcels 메소드로 엑셀 다운로드 실행
        comnUtils.exportExcels({
            excelName: "테스트",// 다운로드 엑셀 파일명 (확장자 제외)
            sheets: [// 다중 Sheet 데이터 배열 ( name : Sheet 명 , sheet : Sheet 데이터 )
                { name: "sheet1", sheet: ws1 },
                { name: "sheet2", sheet: ws2 },
            ],
        });
    }}
/>`}</Sample.Code>
                <Layout>
                    <Layout.Left>
                        <Button role="excelDown" onClick={async () => {}} />
                    </Layout.Left>
                </Layout>
                <Layout></Layout>
            </Sample.Section>

            <Sample.Section
                title="4.프로세스 진행 상태 컴포넌트"
                description={
                    <>
                        - 프로세스의 각 단계별 진행상태를 표시하기 위한 컴포넌트
                        <br />
                        {`<Process data={프로세스 데이터} />`}
                    </>
                }
            >
                <Sample.Table
                    widths={["w-[20%]", "w-[20%]", "w-[20%]", "w-auto"]}
                    data={[
                        ["파라메터", "타입", "기본값", "설명"],
                        ["title", "string", "", "단계 명을 기입"],
                        ["description", "string", "", "단계 설명을 기입"],
                        [
                            "icon",
                            "string",
                            "",
                            <>
                                단계에 대한 아이콘을 설정
                                <br />
                                start(시작) | inProgress(진행중) | error(오류) | completed(완료){" "}
                            </>,
                        ],
                        [
                            "current",
                            "boolean",
                            "false",
                            <>
                                현재 프로세스 여부
                                <br />
                                현재 단계로 설정(true)한 경우 단계명에 표시
                            </>,
                        ],
                        [
                            "line",
                            "boolean | string",
                            "true",
                            <>
                                다음 단계로 연결되는 연결선 스타일에 대한 설정
                                <br />
                                true(일반) | dashed | dotted | double
                            </>,
                        ],
                        [
                            "color",
                            "string",
                            "blue",
                            <>
                                단계를 표시하는 영역의 색상 설정
                                <br />
                                blue(파랑)) | red(빨강) | yellow(노랑) | green(녹색)
                            </>,
                        ],
                        [
                            "lineColor",
                            "string",
                            "blue",
                            <>
                                다음 단계로 연결되는 연결선 색상에 대한 설정
                                <br />
                                blue(파랑)) | red(빨강) | yellow(노랑) | green(녹색)
                            </>,
                        ],
                    ]}
                />
                <Sample.Code>{`// 프로세스에 대한 데이터 설정
import { Process, TProcessItem } from "@/comn/components/Process";

const prcsItm1: TProcessItem[] = [
    {
        icon: "start",
        title: "Start",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "inProgress",
        title: "Step 1",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "inProgress",
        title: "Step 2",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "inProgress",
        title: "Step 3",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "completed",
        title: "End",
        current: true,
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
];

const prcsItm2: TProcessItem[] = [
    {
        icon: "start",
        title: "Start",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
        line: "dashed",
    },
    {
        icon: "inProgress",
        title: "Step 1",
        color: "yellow",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "inProgress",
        title: "Step 2",
        current: true,
        line: "dashed",
        lineColor: "yellow",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "error",
        title: "Step Error",
        color: "red",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
    {
        icon: "completed",
        title: "End",
        description: "단계에 해당하는 간단한 설명을 입력합니다",
    },
];

return (<>
    <Process data={prcsItm1} />
    <Process data={prcsItm2} />
</>)


`}</Sample.Code>

                <Layout direction="col">
                    <Process data={prcsItm1} />
                    <Process data={prcsItm2} />
                </Layout>
                <Layout>
                    <Layout.Right></Layout.Right>
                </Layout>
            </Sample.Section>
        </Sample>
    );
};
